import { createAsyncThunk } from "@reduxjs/toolkit";
import monitoringApi from 'api/monitoringApi';
import { formatQueryParams } from "helpers/format";

export const getLiquidityLogs = createAsyncThunk("Liquidity Logs", async (params: any = {}) => {
  try {
    const response = await monitoringApi.liquidityLogs(formatQueryParams(params));
    return response;
  } catch (error) {
    return error;
  }
});


export const getLogs = async (params: any = {}) => {
  try {
    const response = await monitoringApi.logs(formatQueryParams(params));
    return response;
  } catch (error) {
    return error;
  }
};

export const getTransactionLogs = createAsyncThunk("Transaction Logs", async (params: any = {}) => {
  try {
    const response = await monitoringApi.transactionLogs(formatQueryParams(params));
    return response;
  } catch (error) {
    return error;
  }
});

export const getEventLogs = async (params: any = {}) => {
  try {
    const response = await monitoringApi.eventLogs(formatQueryParams(params));
    return response;
  } catch (error) {
    return error;
  }
};